module.exports = "<div class=\"deliboy_dashboard_logo\">\n<a class=\"brand\">\n <!-- <img src=\"assets/images/title_icon.png\" alt=\"settings\">-->\n  <img src={{titleImg}} alt=\"settings\">\n</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-module/logo.component.html
// module id = ./src/app/shared-module/logo.component.html
// module chunks = main